<!--TITLE-->
<div class="container-fluid pt-120 pb-5">
    <div class="row title-bar">
        <div class="col-12">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h1 class="text-uppercase text-center">Our <span class="text-blue">Cooling</span> Services</h1>
                        <p class="text-center pt-3">Edmontonians have been blessed to enjoy some hot beautiful summers lately! With summer coming earlier and staying later, increase the comfort level of your home with an Air Conditioner. An Air Conditioner for your home has become a necessity in Edmonton. </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--15 YEARS XP BAR-->
<div class="container-fluid">
    <div class="row xp-bar bg-yellow">
        <div class="col-12">
            <div class="container">
                <div class="row">
                    <div class="col-sm-9">
                        <h2 class="text-white text-center">Over 15 Years of Experience</h2>
                        <p class="text-white text-justify pt-3">Trust Eazy Breezy to service your air conditioner when it fails you. We pride ourselves on our strong service background and customer satisfaction!</p>
                    </div>
                    <div class="col-sm-3 text-center mobile-pt">
                        <i class="fa fa-regular fa-gem"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--SERVICES-->
<div class="container-fluid">
    <div class="row">
        <div class="col-lg-6 service-col pb-5">
            <div class="row">
                <div class="col-12">
                    <div class="service-item pt-25 pt-0-360">
                        <div class="service-icon i-circle mr-3 desktop-center-icon"><div class="icon-sprite icon-blue icon-install"></div></div>
                        <div class="service-text">
                            <h1>Air Condition Installation</h1>
                            <p class="pt-3">Tired of sweating through the summer? Let Eazy Breezy help you increase the comfort of your home. With so many options available to you, how can you decide which Air Conditioner is right for your home? Let Eazy Breezy help you decide! With many different brands, we will be able to find a unit that will suit your home and budget.</p>
                            <h3>How Is an Air Conditioner Sized?</h3>
                            <p class="pt-3">We size your Air Conditioner based on the square footage of your home and CFM of your furnace. It is very important not to size your unit too small, so your home is still warm. It is equally as important not to size your unit too large, creating an inefficient system.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="service-item pt-25 pt-0-360">
                        <div class="service-icon i-circle mr-3 desktop-center-icon"><div class="icon-sprite icon-blue icon-maintenance"></div></div>
                        <div class="service-text">
                            <h1>Air Condition Maintenance</h1>
                            <p class="pt-3">Air Conditioner Maintenance is something every homeowner can accomplish. A new filter and a clean condenser coil help increase your air conditioner's efficiency and extend its life.</p>
                            <ol class="pt-3">
                                <li>We recommend changing your furnace filter every 3 - 4 months. By doing this, it will stop your evaporator coil from clogging up with dirt and dust.</li>
                                <li>To clean your condenser coil, use a garden hose with very low pressure to rinse it off.</li>
                            </ol>
                            <p class="pt-3">With these two simple steps, you can successfully extend the life of your Air Conditioner.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="service-item pt-25 pt-0-360">
                        <div class="service-icon i-circle mr-3 desktop-center-icon"><div class="icon-sprite icon-blue icon-repair"></div></div>
                        <div class="service-text">
                            <h1>Air Condition Repair</h1>
                            <p class="pt-3">When your air conditioner fails you, trust Eazy Breezy to make the repairs. With a strong repair background, Eazy Breezy prides ourselves on being able to fix all makes and models of air conditioners. <span class="text-bold">As a family owned and operated business, we are not there to just upsell you to a new air conditioner.</span> We will make an honest assessment of your needs and make a repair whenever possible.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-6 contact-img">
            &nbsp;
        </div>
    </div>
</div>

<!--BOOK AND PHONE BAR-->
<div class="container-fluid">
    <div class="row phone-bar bg-blue">
        <div class="col-12">
            <div class="container">
                <div class="row">
                    <div class="col-sm-4 border-r pb-mobile-20">
                        <h3 class="text-uppercase text-center lh-20 fw-400 text-red">Office</h3>
                        <p class="text-center text-white">587.596.3040</p>
                    </div>
                    <div class="col-sm-4 d-flex justify-content-center border-r pb-mobile-20">
                        <div class="action-button verticle-center-text" routerLink="/contact" href="/contact">
                            <span>BOOK ONLINE</span>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <h3 class="text-uppercase text-center lh-20 fw-400 text-red">Dispatch</h3>
                        <p class="text-center text-white">780.964.3299</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--OTHER SERVICES-->
<div class="container-fluid pt-5">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h1 class="text-center text-uppercase">Other Services</h1>
            </div>
        </div>
        <div class="row pt-3">
            <div class="col-sm-6">
                <div class="card transparent-card">
                    <div class="card-header d-flex justify-content-center">
                        <div class="i-circle">
                            <i class="text-red fa fa-solid fa-fire"></i>
                        </div>
                    </div>
                    <div class="card-body text-center">
                        <h2>Heating</h2>
                        <p class="pt-2">Since Edmonton is known for its cooler climate, our heating experts will help you maximize the comfort level of your home even through our sub-zero winters.<br><a rel="/heating" href="/heating" class="text-red">Read more.</a></p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="card transparent-card">
                    <div class="card-header d-flex justify-content-center">
                        <div class="i-circle rounded-circle">
                            <i class="text-yellow fa fa-solid fa-faucet"></i>
                        </div>
                    </div>
                    <div class="card-body text-center">
                        <h2>Plumbing</h2>
                        <p class="pt-2">Not just HVAC? That's right! Whether you need a new hot water tank, a pipe repaired, or a drain cleared, our plumbing experts are ready to help.<br><a rel="/plumbing" href="/plumbing" class="text-yellow">Read more.</a></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>